<template>
  <div class="chart-container">
    <!-- timeline header -->
    <div class="row">
      <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2">
        <TimelineHeader v-model="selectInputs" :select-category.sync="selectCategory" :content="content" />
      </div>
    </div>

    <!-- timeline chart -->
    <div class="row">
      <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1">
        <TimelineChart v-model="selectInputs" :select-category="selectCategory" />
      </div>
    </div>

    <!-- timeline footer -->
    <div class="chart-container__footer">
      <i>*Milestones are not exhaustive.</i>
    </div>
  </div>
</template>

<script>
import TimelineHeader from '@/components/content/charts/TimelineHeader.vue';
import TimelineChart from '@/components/content/charts/TimelineChart.vue';

export default {
  name: 'Timeline',
  components: {
    TimelineHeader,
    TimelineChart,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectInputs: {
        yearStart: 2020,
        yearEnd: 2020,
        region: 'All regions',
      },
      selectCategory: 'All',
    };
  },
};
</script>

<style lang="scss" scoped>
.chart-container__footer {
  text-align: center;
  margin-top: 24px;
}
</style>
